import { Button, Modal, Text } from '@belong/ui';
import { AppGIF } from 'lease-signing-flow-v2/components/app-gif/app-gif';
import { AppQR } from 'lease-signing-flow-v2/components/app-qr/app-qr';
import { AppStoreBadges } from 'lease-signing-flow-v2/components/app-store-badges/app-store-badges';
import { DownloadAppButton } from 'lease-signing-flow-v2/components/download-app-button/download-app-button';
import { LEASE_SIGNING_FLOW_STRINGS } from 'lease-signing-flow-v2/constants/strings';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};

export const AppModal = ({ isOpen, onDismiss }: Props) => (
  <Modal
    contentClassName="flex"
    isOpen={isOpen}
    name="APP_MODAL"
    onDismiss={onDismiss}
    overlayClassName="z-[99999]"
    size="fullScreen"
  >
    <div className="container flex flex-col items-center pt-2xl">
      <div className="mb-xs text-center sm:max-w-[539px]">
        <Text fontWeight="semibold" variant="h3">
          {LEASE_SIGNING_FLOW_STRINGS['app.modal.title']}
        </Text>
      </div>
      <div className="text-center sm:max-w-[565px]">
        <Text>{LEASE_SIGNING_FLOW_STRINGS['app.modal.subtitle']}</Text>
      </div>
      <div className="mt-2xl flex w-full justify-center">
        <div className="sm:justifiy-start flex w-full flex-col items-center sm:w-auto sm:flex-row sm:items-start md:ml-3xl">
          <AppGIF />
          <div className="mt-xl w-full sm:hidden">
            <DownloadAppButton />
            <div className="mt-xl text-center">
              <Button buttonType="primary" onClick={onDismiss} variant="text">
                {LEASE_SIGNING_FLOW_STRINGS['success.cta']}
              </Button>
            </div>
          </div>
          <div className="ml-2xl hidden md:block">
            <div className="flex flex-col justify-items-start pt-2xl">
              <AppQR />
              <div className="mt-xl flex flex-col place-items-start">
                <div className="mb-xl">
                  <AppStoreBadges />
                </div>
                <Button buttonType="primary" onClick={onDismiss} variant="text">
                  {LEASE_SIGNING_FLOW_STRINGS['success.cta']}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
);
